(function() {
    angular.module('tmx-app').controller('dailyCreditReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'BranchService',
        'lookupService',
        'ReportService',
        'TMX_FINANCE_CONSTANTS',

        function dailyCreditReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            BranchService,
            lookupService,
            ReportService,
            TMX_FINANCE_CONSTANTS
        ) {
            var dailyCreditReportVM = this;
            dailyCreditReportVM.menu = menu;
            dailyCreditReportVM.gridData = new kendo.data.ObservableArray([]);
            dailyCreditReportVM.search = search;
            dailyCreditReportVM.filterEnabled = false;
            dailyCreditReportVM.toggle = toggle;
            dailyCreditReportVM.isOpen = isOpen;
            var exportLoanApplicationNumber = null;
            var exportBranchId = null;
            var exportNationalId=null;
            var exportFromDate=null;
            var exportToDate=null;
    
            dailyCreditReportVM.clear = clear;
    
            dailyCreditReportVM.Decisions = [];
            dailyCreditReportVM.formatColumnName = tmxUtility.formatColumnName;
    //initializing Lookup types from Tmx Finance Constant
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;
    

            var decisionTypes = lookupService.getLocalLookupsByType(lkupType.DecisionTypes);

            if(decisionTypes) {
                dailyCreditReportVM.Decisions = decisionTypes.map((decision)=> {
                    return {
                        HiddenValue: decision.VisibleValue,
                        VisibleValue: decision.VisibleValue
                    }
                });
            }

            dailyCreditReportVM.DecisionDate = new Date();

            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }
            function clear() {
                dailyCreditReportVM.Decision = undefined;
                dailyCreditReportVM.BranchId=undefined;
                dailyCreditReportVM.DecisionDate=null;
                dailyCreditReportVM.LoanOfficerName=undefined;
                dailyCreditReportVM.CreditOfficerName=undefined;
      // dailyCreditReportVM.container.dailyCreditReportGrid.dataSource.read();
            }

      //GetBranchesByUserCompany
            BranchService.getByAction('GetBranchesByUserCompany',true).then(function(response){
                decorateForSelect(response.data);
                dailyCreditReportVM.Branches=response.data;
            });

            function decorateForSelect(arrayOfObj) {
                arrayOfObj.forEach(
                    function (obj) {
                        obj.LookupId=obj.CompanyBranchId;
                        obj.VisibleValue = obj.BranchName;
                        obj.HiddenValue = obj.BranchCode;
                    }
                );
            }

            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            dailyCreditReportVM.exportToPdf = exportToPdf;

            function search() {
                dailyCreditReportVM.container.dailyCreditReportGrid.dataSource.read();
                dailyCreditReportVM.filterEnabled = true;
                exportLoanApplicationNumber = angular.copy(dailyCreditReportVM.LoanApplicationNumber);
                exportBranchId=angular.copy(dailyCreditReportVM.BranchId);
                exportNationalId=angular.copy(dailyCreditReportVM.NationalId);
                exportFromDate = moment(new Date(dailyCreditReportVM.FromDate)).startOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
                exportToDate = moment(new Date(dailyCreditReportVM.ToDate)).endOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
            }

            function exportToPdf() {
                var loanapplicationnumber = exportLoanApplicationNumber
                    ? exportLoanApplicationNumber
                    : null;
                var branchid = exportBranchId
                    ? exportBranchId
                    : null;
                var nationalid = exportNationalId
                    ? exportNationalId
                    : null;
                var offset= -1 * (new Date().getTimezoneOffset());
                var fromdate = exportFromDate
                    ? exportFromDate
                    : null;
                var todate = exportToDate
                    ? exportToDate
                    : null;

                    // Todo: Correction
                OperationReportService.exportOperationReport(loanapplicationnumber,branchid,nationalid,offset,fromdate,todate);
            }


            var gridColumns = [
                {
                    field: "DecisionDate",
                    title: "DecisionDate",
                    type: "date",
                    format: "{0:dd MMM yyyy}",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('DecisionDate')]}}</span>",
                    headerTemplate: "<span>Credit Decision Date</span>"
                },
                {
                    field: "BranchName",
                    title: "BranchName",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('BranchName')]}}</span>",
                    headerTemplate: "<span>Branch Name</span>"
                },
                {
                    field: "LoanNumber",
                    title: "LoanNumber",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('LoanNumber')]}}</span>",
                    headerTemplate: "<span>Loan Application #</span>"
                },
                {
                    field: "ClientName",
                    title: "ClientName",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('ClientName')]}}</span>",
                    headerTemplate: "<span>Client's Name</span>"
                },
                {
                    field: "GuarantorName",
                    title: "GuarantorName",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('GuarantorName')]}}</span>",
                    headerTemplate: "<span>Guarantor's Name</span>"
                },
                {
                    field: "CreditOfficer",
                    title: "CreditOfficer",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('CreditOfficer')]}}</span>",
                    headerTemplate: "<span>Credit Officer</span>"
                },
                {
                    field: "LoanOfficer",
                    title: "LoanOfficer",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('LoanOfficer')]}}</span>",
                    headerTemplate: "<span>Loan Officer</span>"
                },
                {
                    field: "Decision",
                    title: "Decision",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('Decision')]}}</span>",
                    headerTemplate: "<span>Decision</span>"
                },
                {
                    field: "RejectionType",
                    title: "RejectionType",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('RejectionType')]}}</span>",
                    headerTemplate: "<span>Rejection Type(if any)</span>"
                },
                {
                    field: "RejectionReason",
                    title: "RejectionReason",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('RejectionReason')]}}</span>",
                    headerTemplate: "<span>Rejection Reason (if any)</span>"
                },
                {
                    field: "CARecommendedAmount",
                    title: "CARecommendedAmount",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('CARecommendedAmount')]}}</span>",
                    headerTemplate: "<span>CA Recommended Amount</span>"
                },
                {
                    field: "CARecommendedInstallment",
                    title: "CARecommendedInstallment",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('CARecommendedInstallment')]}}</span>",
                    headerTemplate: "<span>CA Recommended Installment</span>"
                },
                {
                    field: "CADBRBefore",
                    title: "CADBRBefore",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('CADBRBefore')]}}</span>",
                    headerTemplate: "<span>CA DBR Before</span>"
                },
                {
                    field: "CADBRAfter",
                    title: "CADBRAfter",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('CADBRAfter')]}}</span>",
                    headerTemplate: "<span>CA DBR After</span>"
                },
                {
                    field: "CreditRationale",
                    title: "CreditRationale",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[DailyCreditReportCtrl.formatColumnName('CreditRationale')]}}</span>",
                    headerTemplate: "<span>Credit Rationale / Comments</span>"
                }
            ];


            dailyCreditReportVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            var loanOfficerName = undefined;
                            var branchid=undefined;
                            var creditOfficerName=undefined;
                            var decision=undefined;
                            var decisionDate= undefined;

                            branchid = dailyCreditReportVM.BranchId;
                            loanOfficerName = dailyCreditReportVM.LoanOfficerName;
                            creditOfficerName = dailyCreditReportVM.CreditOfficerName;
                            decision = dailyCreditReportVM.Decision;
                            if(tmxUtility.exists(dailyCreditReportVM.DecisionDate) && dailyCreditReportVM.DecisionDate != ""){
                                decisionDate = moment(dailyCreditReportVM.DecisionDate).format('YYYY-MM-DD');
                            }

                            var objArgs = {
                                "DecisionDate":decisionDate,
                                "BranchId":branchid,
                                "Decision":decision,
                                "LoanOfficer":loanOfficerName,
                                "CreditOfficer":creditOfficerName
                            };
              
                            var filters = {
                                "StoredProcedure": "sp_daily_credit_report",
                                "Arguments": objArgs,
                                "ReportName": "Daily_Credit_Report"
                            };
              
          
                            dailyCreditReportVM.o = angular.copy(o);
                            dailyCreditReportVM.filters = dailyCreditReportVM.o.data.filter;

                            firebase.logTmxEvent('report',{name:'Daily Credit Report'});
                            ReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function (response) {
              
                                if (response) {
                                    dailyCreditReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });
  
                            dailyCreditReportVM.filterEnabled = true;
            
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 20,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "DailyCreditReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {

                        // var row = sheet.rows[rowIndex];
//          row.cells[8].value = dailyCreditReportVM.formatDateTime(row.cells[8].value);
  //        row.cells[7].value = dailyCreditReportVM.formatDateTime(row.cells[7].value);
                    }
                    columns.forEach(function(column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: gridColumns
            };
  
        }]);
})();
